import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CATS = [
  ["Korean Skincare", "Koreanische Gesichtsbehandlungen", "ab 115 €", "/img/studio-facial.jpg"],
  ["Massage & Wellness", "Ayurveda & Fußreflexzonen", "Preis auf Anfrage", "/img/ayurveda.jpg"],
  ["G8 Body Contouring", "Cellulite- & Körpermassage", "ab 55 €", "/img/g8-geraet.jpg"],
];

export const PriceTeaser = () => (
  <section data-testid="price-teaser" className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 lg:pb-36">
    <div className="grid gap-8 lg:grid-cols-2 lg:items-end">
      <Reveal>
        <Eyebrow index="✦">Beauty, Massage &amp; Wellness</Eyebrow>
        <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-5xl">
          Mehr Rituale <span className="italic text-gold-deep">für dich.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:justify-self-end">
        <p className="inline-flex items-center gap-2 text-sm text-ink-soft"><Sparkles className="h-4 w-4 text-gold-deep" strokeWidth={1.6} /> Individuelle Beratung inklusive</p>
      </Reveal>
    </div>
    <div className="mt-12 grid gap-5 md:grid-cols-3">
      {CATS.map(([title, sub, price, img], i) => (
        <Reveal key={title} delay={i * 0.08}>
          <Link to="/preisliste" data-testid={`price-teaser-${i}`} className="group relative block aspect-[4/5] overflow-hidden rounded-t-full bg-champagne sm:aspect-[3/4]">
            <img src={img} alt={sub} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-espresso/85 via-espresso/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 text-cream">
              <p className="text-[11px] uppercase tracking-[0.24em] text-gold-light">{sub}</p>
              <h3 className="mt-2 font-serif text-3xl">{title}</h3>
              <p className="mt-1 font-serif text-lg italic text-cream/90">{price}</p>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
    <Reveal className="mt-10 flex justify-center">
      <Link to="/preisliste" data-testid="price-teaser-cta" className="btn-gold group inline-flex items-center gap-3 rounded-full px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.24em]">
        Zur Preisliste <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </Reveal>
  </section>
);
